// Implementing Partner (IP) names for Micro Grants, each mapped to the
// district(s) it operates in.
export const IP_DISTRICT_MAP = {
  SRSO: ["Badin"],
  TRDP: ["Tharparkar"],
  "ACT International": ["Thatta"],
  NRSP: ["Sujawal"],
  PMN: ["Larkana"],
};

export const IP_NAME_OPTIONS = Object.keys(IP_DISTRICT_MAP).map((name) => ({
  label: name,
  value: name,
}));

export const ROLE_TO_IP_NAME = {
  SRSO: "SRSO",
  TRDP: "TRDP",
  "ACT INTL": "ACT International",
  NRSP: "NRSP",
  PMN: "PMN",
};
